<template>
  <div class="flex items-center justify-between top-block">
    <a href="/">
      <img
        src="https://s3.amazonaws.com/ma-content/images/2024/logo-light.png"
        alt="Motion Array"
        title="Motion Array"
        style="max-width:106px;"
      >
    </a>

    <div class="ml-auto flex items-center space-x-5 text-primary-light-purple">
      <button
        type="button"
        @click="openSearch"
      >
        <i
          class="fas fa-search"
        />
      </button>
      <router-link
        v-if="isLoggedIn"
        to="/account/details/"
        class="mr-4 drawer-link grey-btn"
      >
        <i class="fas fa-user-circle" />
      </router-link>

      <button
        type="button"
        class="grey-btn"
        @click="onToggleMenu"
      >
        <i
          class="fas"
          :class="open ? 'fa-times' : 'fa-bars'"
        />
      </button>
    </div>
  </div>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import browseEventsData from '@/utils/events/browse-events-data';

export default {
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    open() {
      return this.$store.state.openTopNavDrawer;
    },
  },

  methods: {
    onToggleMenu() {
      this.$store.dispatch('setOpenTopNavDrawer', !this.open);
      if (this.open) {
        eventTracker(analyticsEvents.myAccountArea.menuOpened, { menu: 'top right' });
      }
    },
    openSearch() {
      eventTracker(analyticsEvents.searchAreaClicked, {
        ...browseEventsData({
          $route: this.$route,
          location: 'header',
          categorySlug: this.$store.getters.categoryFilters.slug || '',
        }),
      });
      this.$store.commit('search/SET_OPEN', true);
    },
  },
};
</script>

<style scoped>
.top-block {
  height: 45px;
  padding-left: 16px;
  padding-right: 16px;
}

.grey-btn {
  width: 15px;
}

body.overflow-hidden .top-block {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
